import { OpeningHours as OpeningHoursModel } from '@/types-aggregatore';
import { createOpeningHourObj } from '@/utils/dates';
import Section from '@/app/_components/widgets/profile/section';

type OpeningHoursProps = {
  openingHoursList: OpeningHoursModel[];
};

const OpeningHours = ({ openingHoursList }: OpeningHoursProps) => (
  <Section title="orari" testId="profile opening hours">
    {openingHoursList.map(({ day, openHours }) => {
      const openingHour = createOpeningHourObj(day, openHours);
      return (
        <div key={`${openingHour.dayofweek} - ${openingHour.openhours}`} className="grid grid-cols-2">
          <span className="text-base font-medium text-inherit lg:text-lg">{openingHour.dayofweek}</span>
          <span className="text-base font-medium text-inherit lg:text-lg">{openingHour.openhours}</span>
        </div>
      );
    })}
  </Section>
);

export default OpeningHours;
